const Happy1 = [
    {id: "0", value: "空方向下"},    
    {id: "1", value: "多方向上"},
    {id: "2", value: "盤整型態"},    
  ];  
  
  export default Happy1